import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";

export interface IWbmSelectProps {
  dropdownIsOpen?: boolean;
  width: number;
  forceCloseDep?: boolean;
  className: string;
  options: any[];
  onMenuOpen: () => void;
  onMenuClose: () => void;
  onChange: (value: { value: string }) => void;
  isDisabled: boolean;
  value: any;
  fallback: React.ReactElement;
}

const ClientProvider = React.lazy(
  () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "slide-outs" */
      "./wbmSelectClient"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

const WbmSelect = (props: IWbmSelectProps) => {
  return (
    <>
      <label htmlFor="Category" className="sr-only">
        Category
      </label>
      {ServerSideService.isServerSide ? (
        props.fallback
      ) : (
        <Suspense fallback={props.fallback}>
          <ClientProvider {...props} />
        </Suspense>
      )}
    </>
  );
};

export default WbmSelect;
